export default [
  {
    path: '/admin/data-middle-platform/data-exchange-standard/index',
    name: 'M020044',
    component: () =>
      import(
        '@/views/admin/data-middle-platform/data-exchange-standard/StandardIndex.vue'
      ),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/data-middle-platform/data-exchange-log/index',
    name: 'M020047',
    component: () =>
      import(
        '@/views/admin/data-middle-platform/data-exchange-log/LogIndex.vue'
      ),
    meta: { layout: 'admin' },
  },
  {
    path: '/standard/doc/:encryptId/:credential?',
    name: 'data-ex-doc',
    component: () =>
      import(
        '@/views/admin/data-middle-platform/data-exchange-standard/components/StandardReview.vue'
      ),
    meta: { layout: 'front' },
  },
];
